import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  OtpVerification,
  ReOtpVerification,
} from "../../Redux/Actions/UserAction";

const Verification = () => {
  const home = useSelector((state) => state?.home);
  const otpVerificationList = home?.otpVerificationList;

  const [Otp, setOtp] = useState(new Array(4).fill(""));
  // Resend cooldown (seconds). Starts at 60 on mount and after each resend.
  const [resendIn, setResendIn] = useState(60);

  const dispatch = useDispatch();

  // reset login status
  useEffect(() => {
    // dispatch(logout());
  }, []);

  // TESTING ONLY: SMS gateway is down, so auto-fill the real OTP returned at
  // registration (kept in redux / sessionStorage) — user just taps SUBMIT.
  // REMOVE this once SMS delivery is restored.
  useEffect(() => {
    const real = String(
      otpVerificationList?.otp || sessionStorage.getItem("otp") || ""
    ).replace(/\D/g, "");
    if (/^\d{4}$/.test(real)) {
      setOtp(real.split(""));
    }
  }, [otpVerificationList]);

  // Countdown for the Resend OTP link.
  useEffect(() => {
    if (resendIn <= 0) return undefined;
    const id = setInterval(() => {
      setResendIn((s) => (s <= 1 ? 0 : s - 1));
    }, 1000);
    return () => clearInterval(id);
  }, [resendIn]);

  const handleChange = (e, index) => {
    // Only accept a single digit.
    const value = (e.value || "").replace(/\D/g, "").slice(0, 1);

    // Update the OTP array with the new value
    setOtp([...Otp.map((d, idx) => (idx === index ? value : d))]);

    // Auto-focus next input if value is entered and next input exists
    if (value !== "" && index < 3) {
      // Get all input elements
      const inputs = document.querySelectorAll(".otp-input");
      // Focus the next input
      inputs[index + 1].focus();
    }
  };

  // Paste the whole code at once — distribute each digit to its own box.
  const handlePaste = (e) => {
    e.preventDefault();
    const digits = (e.clipboardData.getData("text") || "")
      .replace(/\D/g, "")
      .slice(0, 4);
    if (!digits) return;
    const next = new Array(4).fill("");
    for (let i = 0; i < digits.length; i += 1) next[i] = digits[i];
    setOtp(next);
    const inputs = document.querySelectorAll(".otp-input");
    const focusIdx = Math.min(digits.length, 3);
    if (inputs[focusIdx]) inputs[focusIdx].focus();
  };

  const handleKeyDown = (e, index) => {
    // Handle backspace key
    if (e.key === "Backspace") {
      // Clear current input if it has a value
      if (Otp[index] !== "") {
        const newOtp = [...Otp];
        newOtp[index] = "";
        setOtp(newOtp);
      }
      // Move to previous input if current input is empty and not the first input
      else if (index > 0) {
        const inputs = document.querySelectorAll(".otp-input");
        inputs[index - 1].focus();

        // Also clear the previous input
        const newOtp = [...Otp];
        newOtp[index - 1] = "";
        setOtp(newOtp);
      }
    }
  };

  const OtpSend = (e) => {
    const otpData = {
      countryCode: otpVerificationList?.countryCode,
      mobileNumber: otpVerificationList?.mobileNumber,
      userId: otpVerificationList?.userId,
      otp: Otp.join(""),
    };
    dispatch(OtpVerification(otpData));
  };

  const ResendOtp = (e) => {
    e.preventDefault();
    if (resendIn > 0) return; // still in cooldown
    const resendData = {
      countryCode: otpVerificationList?.countryCode,
      mobileNumber: otpVerificationList?.mobileNumber,
    };
    dispatch(ReOtpVerification(resendData));
    setResendIn(60); // restart the cooldown
  };

  return (
    <div className="login-reg-area">
      <div className="container">
        <div className="login-reg-wrap" style={{ textAlign: "center" }}>
          <img src="/assets/images/otp-icon.png" alt="" className="img-fluid" />
          <h4 className="mb-3">VERIFICATION</h4>
          <p className="mb-2">Please enter the 4 digit OTP sent to your phone</p>
          <div
            className="row text-center m-4"
            style={{
              textAlign: "center",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {Otp.map((data, index) => {
              return (
                <div className="col-3" key={index}>
                  <input
                    className="form-control row m-2 otp-input"
                    type="text"
                    inputMode="numeric"
                    maxLength="1"
                    value={data}
                    required
                    style={{ textAlign: "center" }}
                    onChange={(e) => handleChange(e.target, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onPaste={handlePaste}
                    onFocus={(e) => e.target.select()}
                  />
                </div>
              );
            })}
            <div className="mt-3"></div>
          </div>

          {resendIn > 0 ? (
            <span
              className="m-2 btn btn-link"
              style={{
                color: "#9aa0a6",
                cursor: "not-allowed",
                textDecoration: "none",
                pointerEvents: "none",
              }}
            >
              Resend OTP in 0:{String(resendIn).padStart(2, "0")}
            </span>
          ) : (
            <a href="#" className="m-2 btn btn-link" onClick={ResendOtp}>
              Resend Otp?
            </a>
          )}

          <button
            type="submit"
            className="btn btn-warning btn-block m-2"
            onClick={OtpSend}
          >
            SUBMIT
          </button>
        </div>
      </div>
    </div>
  );
};

export default Verification;
